var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.isPercentageType)?_c('span',[_vm._v(" "+_vm._s(_vm.tip.value)+"% ")]):_vm._e(),(_vm.isAbsoluteType)?_c('span',[_vm._v(" "+_vm._s(_vm.currencySymbol)+_vm._s(_vm.tip.value)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }